import { Indicator } from '../../../Common/Charts/Indicator';
import { usePeopleWithDisabilitiesChartsDataContext } from './hooks/usePeopleWithDisabilitiesChartsDataContext';

export const PeopleWithDisabilitiesIndicator = () => {
    const { chartData } = usePeopleWithDisabilitiesChartsDataContext();

    return (
        <Indicator
            title={'Indice de Pessoas com Deficiência'}
            indicatorValue={chartData?.indicators?.percentagePeopleWithDisabilities}
        />
    );
};
